import { BarChart3 } from "lucide-react";
import { cn } from "@/utils/cn";

export function EmptyChartState({
  message = "No data yet for this period",
  height = 220,
  className,
}: {
  message?: string;
  height?: number;
  className?: string;
}) {
  return (
    <div
      style={{ height }}
      className={cn(
        "flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-border/80 bg-cream-100/50 p-6 text-center",
        className,
      )}
    >
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-cream-200 text-ink-faint">
        <BarChart3 className="h-5 w-5" />
      </div>
      <p className="text-xs font-medium text-ink-faint">{message}</p>
    </div>
  );
}
